var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeHearts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 89.48 89.566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3278 41.2977C33.5112 31.0977 45.3278 28.7519 52.8862 32.4102C61.0945 36.3769 64.8195 47.7061 61.257 60.9977C59.082 70.0394 50.357 80.9436 42.632 88.6519C41.8445 89.4394 40.6945 89.7477 39.6195 89.4602C29.0737 86.6477 16.0653 81.5644 9.66116 74.8227C-0.072175 65.0935 -2.50968 53.4227 2.61532 45.8811C7.33199 38.9311 18.7403 35.0561 28.3278 41.2977ZM27.4945 48.6436C20.6862 41.8477 11.3653 44.1227 7.78616 49.3894C6.04449 51.9519 5.80699 55.1977 6.72366 58.6186C7.77366 62.5394 10.3112 66.6436 14.107 70.4269C14.1278 70.4519 14.1487 70.4727 14.1695 70.4936C19.5653 76.1977 30.332 80.3602 39.4862 82.9394C46.1237 76.1311 53.3695 67.1394 55.1862 59.5061C55.1945 59.4727 55.2028 59.4435 55.2112 59.4144C56.6028 54.2394 56.7487 49.4144 55.6987 45.4936C54.782 42.0727 52.9528 39.3811 50.1653 38.0352C44.432 35.2602 35.2237 37.9519 32.7195 47.2436C32.432 48.3186 31.5903 49.1602 30.5112 49.4477C29.4362 49.7352 28.2862 49.4311 27.4945 48.6436Z",
    fill: "url(#paint0_linear_0_85)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3528 54.9769C59.7445 55.5936 57.9362 54.7852 57.3195 53.1769C56.6987 51.5644 57.507 49.7561 59.1153 49.1394C65.507 46.6894 71.6653 43.5644 75.3112 39.7102C75.332 39.6852 75.3528 39.6644 75.3737 39.6436C79.1695 35.8561 81.707 31.7519 82.757 27.8311C83.6737 24.4102 83.4362 21.1644 81.6945 18.6061C78.1153 13.3352 68.7945 11.0602 61.9862 17.8561C61.1945 18.6436 60.0445 18.9519 58.9695 18.6602C57.8903 18.3727 57.0487 17.5311 56.7612 16.4561C54.257 7.16439 45.0487 4.47272 39.3153 7.24772C36.5278 8.59772 34.6987 11.2894 33.782 14.7061C32.732 18.6269 32.8778 23.4519 34.2695 28.6311C34.2778 28.6602 34.2862 28.6894 34.2945 28.7186C34.807 30.8852 35.7903 33.1686 37.0612 35.4852C37.8945 36.9977 37.3403 38.8977 35.8278 39.7269C34.3153 40.5602 32.4153 40.0061 31.5862 38.4936C30.032 35.6602 28.8612 32.8602 28.2237 30.2061C24.6612 16.9144 28.3862 5.59356 36.5945 1.62272C44.1528 -2.03561 55.9695 0.310224 61.1528 10.5144C70.7403 4.26856 82.1487 8.14772 86.8653 15.0936C91.9862 22.6352 89.5528 34.3061 79.8487 44.0061C75.6612 48.4311 68.6862 52.1644 61.3528 54.9769Z",
    fill: "url(#paint1_linear_0_85)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4529 16.2936C21.2237 17.8352 20.5987 19.7144 19.0529 20.4852C17.5112 21.2561 15.6321 20.6311 14.8612 19.0852L12.7779 14.9186C12.0071 13.3769 12.6321 11.4977 14.1779 10.7269C15.7196 9.95606 17.5987 10.5811 18.3696 12.1269L20.4529 16.2936Z",
    fill: "var(--fill-0, #119ED9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9446 73.2519C66.1737 71.7102 66.7987 69.8311 68.3446 69.0602C69.8862 68.2894 71.7654 68.9144 72.5362 70.4602L74.6196 74.6269C75.3904 76.1686 74.7654 78.0477 73.2196 78.8186C71.6779 79.5894 69.7987 78.9644 69.0279 77.4186L66.9446 73.2519Z",
    fill: "var(--fill-0, #119ED9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7196 35.0686C9.17791 35.8394 7.29875 35.2144 6.52791 33.6686C5.75708 32.1269 6.38208 30.2477 7.92791 29.4769L12.0946 27.3936C13.6362 26.6227 15.5154 27.2477 16.2862 28.7936C17.0571 30.3352 16.4321 32.2144 14.8862 32.9852L10.7196 35.0686Z",
    fill: "var(--fill-0, #119ED9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6779 54.4769C78.2196 53.7061 80.0987 54.3311 80.8696 55.8769C81.6404 57.4186 81.0154 59.2977 79.4696 60.0686L75.3029 62.1519C73.7612 62.9227 71.8821 62.2977 71.1113 60.7519C70.3404 59.2102 70.9654 57.3311 72.5113 56.5602L76.6779 54.4769Z",
    fill: "var(--fill-0, #119ED9)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_85",
    x1: -0.54365,
    y1: 3.90099,
    x2: 104.972,
    y2: 39.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_85",
    x1: -0.54365,
    y1: 3.90099,
    x2: 104.972,
    y2: 39.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeHearts);
export default __webpack_public_path__ + "static/media/welcome_hearts.61291046f351ac08098316ae04e0eb46.svg";
export { ForwardRef as ReactComponent };